import { Card, CardActions, CardContent, Divider } from '@mui/material';
import styles from './ccf-contact-history-card.module.scss';
import {
  CcfBox,
  CcfCallOutboundIcon,
  CcfChatIcon,
  CcfEmailIcon,
  CcfFacebookIcon,
  CcfInstaIcon,
  CcfLinkedinIcon,
  CcfPhoneInboundIcon,
  CcfTypography,
  CcfXIcon,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import CcfContactHistoryModal from '../ccf-contact-history-modal/ccf-contact-history-modal';

/* eslint-disable-next-line */
export interface CcfContactHistoryCardProps {
  contact: any;
}

/**
 * used to show contact history card
 * @param props - CcfContactHistoryCardProps
 * @example ` <CcfContactHistoryCard />`
 */
export function CcfContactHistoryCard(props: CcfContactHistoryCardProps) {
  const { contact } = props;
  const [showModal, setShowModal] = useState(false);

  /**
   * Used to format contact history date and time
   * @param time -string
   * @example - formatDateTimeHandler()
   */
  const formatDateTimeHandler = (time: string) => {
    const date = new Date(time);

    return date.toLocaleDateString('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  /**
   * Function to render Icon for Skill
   * @example renderIconForSkill()
   */
  const renderIconForSkill = (skill: string) => {
    switch (skill) {
      case 'Customer Support':
        return (
          <CcfCallOutboundIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.skillIcon}
          />
        );
      case 'Outbound Voice':
        return (
          <CcfCallOutboundIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.skillIcon}
          />
        );
      case 'Inbound Voice':
        return (
          <CcfPhoneInboundIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.skillIcon}
          />
        );
      case 'Email':
        return (
          <CcfEmailIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.skillIcon}
          />
        );
      case 'Chat':
        return (
          <CcfChatIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.chatIcon}
          />
        );
      case 'Instagram':
        return (
          <CcfInstaIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.instaIcon}
          />
        );
      case 'X':
        return (
          <CcfXIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            fontSize="large"
            className={styles.twitterIcon}
          />
        );
      case 'Facebook':
        return (
          <CcfFacebookIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            fontSize="large"
            className={styles.twitterIcon}
          />
        );
      case 'Linkedin':
        return (
          <CcfLinkedinIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            fontSize="large"
            className={styles.twitterIcon}
          />
        );
      default:
        return (
          <CcfPhoneInboundIcon
            id={`agent_contactHistory_skill_icon_${skill}`}
            className={styles.skillIcon}
          />
        );
    }
  };

  /**
   * Used to handle the modal close event
   * @example -
   */
  const contactHistoryDetailsHandler = () => {
    setShowModal(true);
  };

  /**
   * Used to handle the modal close event
   * @example -
   */
  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        style={{ marginBottom: '5px' }}
        onClick={contactHistoryDetailsHandler}
      >
        <CardContent className={styles.contactHistoryDetails}>
          <CcfBox className={styles.contactHistoryNameBlock}>
            <CcfBox>
              <CcfTypography
                className={`${styles.txt} ${styles.contactNameTxt}`}
              >
                {contact.customer}
              </CcfTypography>
            </CcfBox>
            <CcfBox className={styles.contactChannel}>
              {renderIconForSkill(contact.skill)}
              <CcfTypography className={styles.txt}>
                {contact.channel}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
          <CcfBox className={styles.contactHistoryStatusBlock}>
            <CcfBox>
              <CcfTypography className={`${styles.txt} ${styles.contactDate}`}>
                {formatDateTimeHandler(contact.time)}
              </CcfTypography>
            </CcfBox>
            <CcfBox>
              <CcfTypography
                id={`agent_contactHistory_status_${contact.status}`}
                className={styles.txt}
              >
                {contact.status}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
        </CardContent>
      </Card>
      <CcfContactHistoryModal
        handleModalClose={handleModalClose}
        renderIconForSkill={renderIconForSkill}
        formatDateTimeHandler={formatDateTimeHandler}
        contact={contact}
        open={showModal}
      />
    </>
  );
}

export default CcfContactHistoryCard;
